package features.videoDetails.data.model

import kotlinx.serialization.Serializable

@Serializable
data class FavoriteEntity(
    val videoId: String,
    val imdbId: String? = null,
    val kinopoiskId: String? = null,
    val imageUrl: String? = null,
    val title: String? = null,
    val isTvShow: Boolean,
    val isDeleted: Boolean,
    val changedAt: String,
)
